<div class="flex flex-col gap-1" [class.w-full]="fullWidth">
    @if (label) {
        <label class="font-bold text-black text-left">{{ label }}</label>
    }

    <div class="w-full flex">
        <!-- Input -->
        <div class="relative flex-1">
            <input
                #inputRef
                type="text"
                [placeholder]="placeholder"
                [disabled]="disabled"
                [value]="value"
                (input)="onInput($event)"
                (keypress)="onKeyPress($event)"
                class="w-full h-8 pl-3 pr-8 text-sm border border-gray-300 border-r-0 rounded-l-lg outline-none bg-white text-gray-700 placeholder-gray-400 focus:ring-2 focus:ring-emerald-300 focus:border-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
            />

            <!-- Botão limpar -->
            <button
                *ngIf="value"
                (click)="clear()"
                type="button"
                class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer transition-colors duration-150"
            >
                <svg
                    class="w-3.5 h-3.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                    />
                </svg>
            </button>
        </div>

        <!-- Botão busca -->
        <button
            type="button"
            [disabled]="disabled || loading"
            (click)="emitSearch()"
            class="h-8 px-4 flex items-center justify-center gap-2 bg-primary text-white text-sm font-medium border border-primary rounded-r-lg cursor-pointer shadow-md hover:bg-primary-hover hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/40 active:translate-y-0 active:shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
        >
            <!-- Spinner -->
            <svg
                *ngIf="loading"
                class="animate-spin h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                />
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8z"
                />
            </svg>

            <!-- Ícone busca -->
            <svg
                *ngIf="!loading"
                class="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
                />
            </svg>
        </button>
    </div>
</div>
